import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  participantArea: {
    paddingRight: theme.spacing(2),
  }
//   borderLeft500: {
//     borderLeft: '1px solid #e0e0e0'
// },
}));